import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

import { SiteService } from '../../../services/site.service'

@Component({
    selector: 'app-request-summary',
    templateUrl: './request-summary.component.html',
    styleUrls: ['./request-summary.component.scss'],
    standalone: false
})
export class RequestSummaryComponent implements OnInit 
{
	referenceNumber: string = ''
	heading: string = ''

	constructor(
		private siteService: SiteService,
		private translateService: TranslateService
	) 
	{ 
	}

	ngOnInit() 
	{
		if (this.siteService.viewParameters.hasOwnProperty('requestSummary') &&
			this.siteService.viewParameters.requestSummary.hasOwnProperty('referenceNumber') &&
			this.siteService.viewParameters.requestSummary.hasOwnProperty('heading') &&
			this.siteService.viewParameters.requestSummary.hasOwnProperty('data'))
		{
			this.referenceNumber = this.siteService.viewParameters.requestSummary.referenceNumber
			this.heading = this.siteService.viewParameters.requestSummary.heading

			if ((this.referenceNumber != undefined) && (this.referenceNumber != ''))
			{
				this.retrieveInfo()
			}	  
		}
	}

	retrieveInfo()
	{
		const tableBody = document.querySelector("#dataTable tbody");

		if (tableBody) 
		{
			this.siteService.viewParameters.requestSummary.data.forEach(item => {
				const row = document.createElement("tr")

				const keyCell = document.createElement("td")
				keyCell.textContent = item.key

				const spaceCell = document.createElement("td")
				spaceCell.textContent = '    '
				spaceCell.style.whiteSpace = 'pre'

				const valueCell = document.createElement("td")
				valueCell.textContent = item.value

				row.appendChild(keyCell)
				row.appendChild(spaceCell)
				row.appendChild(valueCell)
				tableBody.appendChild(row)
			})
		}
	}

	print(): void
	{
		this.siteService.printHtmlElement('printSummarySectionId', this.translateService.instant('REQUEST_SUMMARY_HEADING'))
	}
}
